/**
 * Copy text to the clipboard.
 *
 * `navigator.clipboard` needs a secure context, so the textarea fallback covers
 * plain-HTTP origins and older browsers. Same approach CodeExample uses inline.
 */
export const copyToClipboard = async (value: string): Promise<void> => {
	if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
		await navigator.clipboard.writeText(value);
		return;
	}

	if (typeof document === 'undefined') return;

	const element = document.createElement('textarea');
	element.value = value;
	element.setAttribute('readonly', 'true');
	element.style.position = 'absolute';
	element.style.left = '-9999px';
	document.body.appendChild(element);
	element.select();
	document.execCommand('copy');
	document.body.removeChild(element);
};
